import React, { SFC } from "react";
import withContentWrap, { PropsType as WithContentWrapProps } from "../../hoc/withContentWrap";
import withVerticalSpacing, { PropsType as WithVerticalSpacingProps } from "../../hoc/withVerticalSpacing";
import Tile from "../Tile";
import "./style.scss";

type PropsType = HTMLProps<HTMLDivElement> & WithVerticalSpacingProps & WithContentWrapProps;

const News = (props): SFC => {
    return (
        <div id={props.id} className="News">
            {props.children}
        </div>
    );
};

export default withVerticalSpacing(withContentWrap(News));
